import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { DateRoomType } from '../models/date-room-type';
import { Observable } from 'rxjs/Observable';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { OverviewHttpService } from './overview.http.service';
import { List } from 'immutable';

@Injectable()
export class OverviewStore {

  private currentDateRoomTypeSummaryList: BehaviorSubject<List<DateRoomType>> = new BehaviorSubject(null);

  constructor(
    private flashMessagesService: FlashMessagesService,
    private overviewHttpService: OverviewHttpService,
  ) {}

  get dateStaySummary(): Observable<List<DateRoomType>> {
    return this.currentDateRoomTypeSummaryList.asObservable();
  }

  public vendorDateStaySummary(eventPartyId: number): Observable<DateRoomType> {
    return this.currentDateRoomTypeSummaryList
        .map(dateRoomTypeSummaries => dateRoomTypeSummaries != null ?
          dateRoomTypeSummaries.filter(dateRoomTypeSummary => dateRoomTypeSummary.eventPartyId === eventPartyId)[0] : null);
  }

  /**
   * Has to be called to retrieve Date Room Type Summary.
   * Is called by resolver.
   *
   * @param eventId
   * @returns DateRoomTypeDetail list
   */
  loadDateRoomTypeSummary(eventId: number): Observable<List<DateRoomType>> {
    return this.overviewHttpService.getDateRoomTypeSummary(eventId)
      .catch((error: any) => {
        this.flashMessagesService.error(
          'MESSAGES.ERROR.COULD_NOT_GET_DATE_ROOM_TYPE_SUMMARY',
          `Error retrieving summary: Total Rooms By Date & Room Type: ${error}`
        );
        return Observable.throw(error);
      })
      .map((res: List<DateRoomType>) => {
        this.currentDateRoomTypeSummaryList.next(res);
        return res;
      });
  }

  /**
   * Has to be called to retrieve Date Room Type Summary.
   * Is called by resolver.
   *
   * @param eventId
   * @param eventPartyId
   * @returns DateRoomTypeDetail list
   */
  loadDateRoomTypeSummaryByParty(eventId: number, eventPartyId: number): Observable<List<DateRoomType>> {
    return this.overviewHttpService.getDateRoomTypeSummaryByParty(eventId, eventPartyId)
      .catch((error: any) => {
        this.flashMessagesService.error(
          'MESSAGES.ERROR.COULD_NOT_GET_DATE_ROOM_TYPE_SUMMARY',
          `Error retrieving summary: Total Rooms By Date & Room Type: ${error}`
        );
        return Observable.throw(error);
      })
      .map((res: List<DateRoomType>) => {
        this.currentDateRoomTypeSummaryList.next(res);
        return res;
      });
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/overview.store.ts